import { CustomApplication } from 'src/app/CustomApplication';

export class AlertComponent {

    constructor() {}

    static async showAlert(title: string, message: string, handlerOnDidDismiss?, buttons: Array<any> = [{
        text: 'OK',
        role: 'ok'
    }]): Promise<HTMLIonAlertElement> {
        const alert = await CustomApplication.instanceAlertCtrl.create({
            header: title,
            message: message,
            buttons
        });
        await alert.present();
        
        alert.onDidDismiss().then(() => {
            if (handlerOnDidDismiss) {
                handlerOnDidDismiss()
            }
        })
        return alert;
    }

    
}